import angular from 'angular';
import config from '../../../cmsCore/ConfigModule/ConfigModule'
import authService from '../../../cmsCore/Auth/CMSAuthService';

export default angular.module('cms.mail.export.template', [config, authService]).factory('ExportMailTemplateService',
  function(CONFIG, CMSAuthService) {

    this.getUrl = (id) => {

      let url = CONFIG.API_URL + '/mails/' + id + '/html';
      url += '?_format=json&start=0&limit=0&format=csv&Authorization=';
      url += CMSAuthService.getToken();
      return url;
    };

    return this;

  }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Mails/Services/ExportMailTemplateService.js